// regions from https://docs.google.com/spreadsheets/d/1LYEqb820SqPxDLOnDC8qxAEqddNaz9RZu6jbyuM7868/edit#gid=1188894786
export const COUNTRIES = [
  { label: 'Afghanistan', value: 'AF', parent: 'Asia' },
  { label: 'Aland Islands', value: 'AX', parent: 'Europe' },
  { label: 'Albania', value: 'AL', parent: 'Europe' },
  { label: 'Algeria', value: 'DZ', parent: 'Africa' },
  { label: 'American Samoa', value: 'AS', parent: 'Oceania' },
  { label: 'Andorra', value: 'AD', parent: 'Europe' },
  { label: 'Angola', value: 'AO', parent: 'Africa' },
  { label: 'Anguilla', value: 'AI', parent: 'Latin America & Caribbean' },
  { label: 'Antarctica', value: 'AQ', parent: '' },
  {
    label: 'Antigua and Barbuda',
    value: 'AG',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Argentina', value: 'AR', parent: 'Latin America & Caribbean' },
  { label: 'Armenia', value: 'AM', parent: 'Asia' },
  { label: 'Aruba', value: 'AW', parent: 'Latin America & Caribbean' },
  { label: 'Australia', value: 'AU', parent: 'Oceania' },
  { label: 'Austria', value: 'AT', parent: 'Europe' },
  { label: 'Azerbaijan', value: 'AZ', parent: 'Asia' },
  { label: 'Bahamas', value: 'BS', parent: 'Latin America & Caribbean' },
  { label: 'Bahrain', value: 'BH', parent: 'Asia' },
  { label: 'Bangladesh', value: 'BD', parent: 'Asia' },
  { label: 'Barbados', value: 'BB', parent: 'Latin America & Caribbean' },
  { label: 'Belarus', value: 'BY', parent: 'Europe' },
  { label: 'Belgium', value: 'BE', parent: 'Europe' },
  { label: 'Belize', value: 'BZ', parent: 'Latin America & Caribbean' },
  { label: 'Benin', value: 'BJ', parent: 'Africa' },
  { label: 'Bermuda', value: 'BM', parent: 'North America' },
  { label: 'Bhutan', value: 'BT', parent: 'Asia' },
  {
    label: 'Bolivia, Plurinational State of',
    value: 'BO',
    parent: 'Latin America & Caribbean',
  },
  {
    label: 'Bonaire, Sint Eustatius and Saba',
    value: 'BQ',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Bosnia and Herzegovina', value: 'BA', parent: 'Europe' },
  { label: 'Botswana', value: 'BW', parent: 'Africa' },
  { label: 'Brazil', value: 'BR', parent: 'Latin America & Caribbean' },
  { label: 'British Indian Ocean Territory', value: 'IO', parent: 'Africa' },
  { label: 'Brunei Durussalam', value: 'BN', parent: 'Asia' },
  { label: 'Bulgaria', value: 'BG', parent: 'Europe' },
  { label: 'Burkina Faso', value: 'BF', parent: 'Africa' },
  { label: 'Burundi', value: 'BI', parent: 'Africa' },
  { label: 'Cambodia', value: 'KH', parent: 'Asia' },
  { label: 'Cameroon', value: 'CM', parent: 'Africa' },
  { label: 'Canada', value: 'CA', parent: 'North America' },
  { label: 'Cape Verde', value: 'CV', parent: 'Africa' },
  { label: 'Cayman Islands', value: 'KY', parent: 'Latin America & Caribbean' },
  { label: 'Central African Republic', value: 'CF', parent: 'Africa' },
  { label: 'Chad', value: 'TD', parent: 'Africa' },
  { label: 'Chile', value: 'CL', parent: 'Latin America & Caribbean' },
  { label: 'China', value: 'CN', parent: 'Asia' },
  { label: 'Cocos (Keeling) Islands', value: 'CC', parent: 'Oceania' },
  { label: 'Colombia', value: 'CO', parent: 'Latin America & Caribbean' },
  { label: 'Comoros', value: 'KM', parent: 'Africa' },
  { label: 'Congo', value: 'CG', parent: 'Africa' },
  {
    label: 'Congo, the Democratic Republic of the',
    value: 'CD',
    parent: 'Africa',
  },
  { label: 'Cook Islands', value: 'CK', parent: 'Oceania' },
  { label: 'Costa Rica', value: 'CR', parent: 'Latin America & Caribbean' },
  { label: "Cote d'Ivoire", value: 'CI', parent: 'Africa' },
  { label: 'Croatia', value: 'HR', parent: 'Europe' },
  { label: 'Cuba', value: 'CU', parent: 'Latin America & Caribbean' },
  { label: 'Curaçao', value: 'CW', parent: 'Latin America & Caribbean' },
  { label: 'Cyprus', value: 'CY', parent: 'Asia' },
  { label: 'Czech Republic', value: 'CZ', parent: 'Europe' },
  { label: 'Denmark', value: 'DK', parent: 'Europe' },
  { label: 'Djibouti', value: 'DJ', parent: 'Africa' },
  { label: 'Dominica', value: 'DM', parent: 'Latin America & Caribbean' },
  {
    label: 'Dominican Republic',
    value: 'DO',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Ecuador', value: 'EC', parent: 'Latin America & Caribbean' },
  { label: 'Egypt', value: 'EG', parent: 'Africa' },
  { label: 'El Salvador', value: 'SV', parent: 'Latin America & Caribbean' },
  { label: 'Equatorial Guinea', value: 'GQ', parent: 'Africa' },
  { label: 'Eritrea', value: 'ER', parent: 'Africa' },
  { label: 'Estonia', value: 'EE', parent: 'Europe' },
  { label: 'Eswatini', value: 'SZ', parent: 'Africa' },
  { label: 'Ethiopia', value: 'ET', parent: 'Africa' },
  {
    label: 'Falkland Islands (Malvinas)',
    value: 'FK',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Faroe Islands', value: 'FO', parent: 'Europe' },
  { label: 'Fiji', value: 'FJ', parent: 'Oceania' },
  { label: 'Finland', value: 'FI', parent: 'Europe' },
  { label: 'France', value: 'FR', parent: 'Europe' },
  { label: 'French Guiana', value: 'GF', parent: 'Latin America & Caribbean' },
  { label: 'French Polynesia', value: 'PF', parent: 'Oceania' },
  { label: 'French Southern Territories', value: 'TF', parent: 'Africa' },
  { label: 'Gabon', value: 'GA', parent: 'Africa' },
  { label: 'Gambia', value: 'GM', parent: 'Africa' },
  { label: 'Georgia', value: 'GE', parent: 'Asia' },
  { label: 'Germany', value: 'DE', parent: 'Europe' },
  { label: 'Ghana', value: 'GH', parent: 'Africa' },
  { label: 'Gibraltar', value: 'GI', parent: 'Europe' },
  { label: 'Greece', value: 'GR', parent: 'Europe' },
  { label: 'Greenland', value: 'GL', parent: 'North America' },
  { label: 'Grenada', value: 'GD', parent: 'Latin America & Caribbean' },
  { label: 'Guadeloupe', value: 'GP', parent: 'Latin America & Caribbean' },
  { label: 'Guam', value: 'GU', parent: 'Oceania' },
  { label: 'Guatemala', value: 'GT', parent: 'Latin America & Caribbean' },
  { label: 'Guernsey', value: 'GG', parent: 'Europe' },
  { label: 'Guinea', value: 'GN', parent: 'Africa' },
  { label: 'Guinea-Bissau', value: 'GW', parent: 'Africa' },
  { label: 'Guyana', value: 'GY', parent: 'Latin America & Caribbean' },
  { label: 'Haiti', value: 'HT', parent: 'Latin America & Caribbean' },
  { label: 'Holy See', value: 'VA', parent: 'Europe' },
  { label: 'Honduras', value: 'HN', parent: 'Latin America & Caribbean' },
  { label: 'Hong Kong', value: 'HK', parent: 'Asia' },
  { label: 'Hungary', value: 'HU', parent: 'Europe' },
  { label: 'Iceland', value: 'IS', parent: 'Europe' },
  { label: 'India', value: 'IN', parent: 'Asia' },
  { label: 'Indonesia', value: 'ID', parent: 'Asia' },
  { label: 'Iran, Islamic Republic of', value: 'IR', parent: 'Asia' },
  { label: 'Iraq', value: 'IQ', parent: 'Asia' },
  { label: 'Ireland', value: 'IE', parent: 'Europe' },
  { label: 'Isle of Man', value: 'IM', parent: 'Europe' },
  { label: 'Israel', value: 'IL', parent: 'Asia' },
  { label: 'Italy', value: 'IT', parent: 'Europe' },
  { label: 'Jamaica', value: 'JM', parent: 'Latin America & Caribbean' },
  { label: 'Japan', value: 'JP', parent: 'Asia' },
  { label: 'Jersey', value: 'JE', parent: 'Europe' },
  { label: 'Jordan', value: 'JO', parent: 'Asia' },
  { label: 'Kazakhstan', value: 'KZ', parent: 'Asia' },
  { label: 'Kenya', value: 'KE', parent: 'Africa' },
  { label: 'Kiribati', value: 'KI', parent: 'Oceania' },
  {
    label: "Korea, Democratic People's Republic of",
    value: 'KP',
    parent: 'Asia',
  },
  { label: 'Korea, Republic of', value: 'KR', parent: 'Asia' },
  { label: 'Kuwait', value: 'KW', parent: 'Asia' },
  { label: 'Kyrgyzstan', value: 'KG', parent: 'Asia' },
  { label: "Lao People's Democratic Republic", value: 'LA', parent: 'Asia' },
  { label: 'Latvia', value: 'LV', parent: 'Europe' },
  { label: 'Lebanon', value: 'LB', parent: 'Asia' },
  { label: 'Lesotho', value: 'LS', parent: 'Africa' },
  { label: 'Liberia', value: 'LR', parent: 'Africa' },
  { label: 'Libya', value: 'LY', parent: 'Africa' },
  { label: 'Liechtenstein', value: 'LI', parent: 'Europe' },
  { label: 'Lithuania', value: 'LT', parent: 'Europe' },
  { label: 'Luxembourg', value: 'LU', parent: 'Europe' },
  { label: 'Macao', value: 'MO', parent: 'Asia' },
  {
    label: 'Macedonia, the former Yugoslav Republic of',
    value: 'MK',
    parent: 'Europe',
  },
  { label: 'Madagascar', value: 'MG', parent: 'Africa' },
  { label: 'Malawi', value: 'MW', parent: 'Africa' },
  { label: 'Malaysia', value: 'MY', parent: 'Asia' },
  { label: 'Maldives', value: 'MV', parent: 'Asia' },
  { label: 'Mali', value: 'ML', parent: 'Africa' },
  { label: 'Malta', value: 'MT', parent: 'Europe' },
  { label: 'Marshall Islands', value: 'MH', parent: 'Oceania' },
  { label: 'Martinique', value: 'MQ', parent: 'Latin America & Caribbean' },
  { label: 'Mauritania', value: 'MR', parent: 'Africa' },
  { label: 'Mauritius', value: 'MU', parent: 'Africa' },
  { label: 'Mayotte', value: 'YT', parent: 'Africa' },
  { label: 'Mexico', value: 'MX', parent: 'Latin America & Caribbean' },
  { label: 'Micronesia (Federated States of)', value: 'FM', parent: 'Oceania' },
  { label: 'Moldova, Republic of', value: 'MD', parent: 'Europe' },
  { label: 'Monaco', value: 'MC', parent: 'Europe' },
  { label: 'Mongolia', value: 'MN', parent: 'Asia' },
  { label: 'Montenegro', value: 'ME', parent: 'Europe' },
  { label: 'Montserrat', value: 'MS', parent: 'Latin America & Caribbean' },
  { label: 'Morocco', value: 'MA', parent: 'Africa' },
  { label: 'Mozambique', value: 'MZ', parent: 'Africa' },
  { label: 'Myanmar', value: 'MM', parent: 'Asia' },
  { label: 'Namibia', value: 'NA', parent: 'Africa' },
  { label: 'Nauru', value: 'NR', parent: 'Oceania' },
  { label: 'Nepal', value: 'NP', parent: 'Asia' },
  { label: 'Netherlands', value: 'NL', parent: 'Europe' },
  { label: 'New Caledonia', value: 'NC', parent: 'Oceania' },
  { label: 'New Zealand', value: 'NZ', parent: 'Oceania' },
  { label: 'Nicaragua', value: 'NI', parent: 'Latin America & Caribbean' },
  { label: 'Niger', value: 'NE', parent: 'Africa' },
  { label: 'Nigeria', value: 'NG', parent: 'Africa' },
  { label: 'Niue', value: 'NU', parent: 'Oceania' },
  { label: 'Norfolk Island', value: 'NF', parent: 'Oceania' },
  { label: 'Northern Mariana Islands', value: 'MP', parent: 'Oceania' },
  { label: 'Norway', value: 'NO', parent: 'Europe' },
  { label: 'Oman', value: 'OM', parent: 'Asia' },
  { label: 'Pakistan', value: 'PK', parent: 'Asia' },
  { label: 'Palau', value: 'PW', parent: 'Oceania' },
  { label: 'Palestine', value: 'PS', parent: 'Asia' },
  { label: 'Panama', value: 'PA', parent: 'Latin America & Caribbean' },
  { label: 'Papua New Guinea', value: 'PG', parent: 'Oceania' },
  { label: 'Paraguay', value: 'PY', parent: 'Latin America & Caribbean' },
  { label: 'Peru', value: 'PE', parent: 'Latin America & Caribbean' },
  { label: 'Philippines', value: 'PH', parent: 'Asia' },
  { label: 'Pitcairn', value: 'PN', parent: 'Oceania' },
  { label: 'Poland', value: 'PL', parent: 'Europe' },
  { label: 'Portugal', value: 'PT', parent: 'Europe' },
  { label: 'Puerto Rico', value: 'PR', parent: 'Latin America & Caribbean' },
  { label: 'Qatar', value: 'QA', parent: 'Asia' },
  { label: 'Reunion', value: 'RE', parent: 'Africa' },
  { label: 'Romania', value: 'RO', parent: 'Europe' },
  { label: 'Russia', value: 'RU', parent: 'Europe' },
  { label: 'Rwanda', value: 'RW', parent: 'Africa' },
  {
    label: 'Saint Barthélemy',
    value: 'BL',
    parent: 'Latin America & Caribbean',
  },
  {
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'SH',
    parent: 'Africa',
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'KN',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Saint Lucia', value: 'LC', parent: 'Latin America & Caribbean' },
  {
    label: 'Saint Martin (French part)',
    value: 'MF',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Saint Pierre and Miquelon', value: 'PM', parent: 'North America' },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'VC',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Samoa', value: 'WS', parent: 'Oceania' },
  { label: 'San Marino', value: 'SM', parent: 'Europe' },
  { label: 'Sao Tome and Principe', value: 'ST', parent: 'Africa' },
  { label: 'Saudi Arabia', value: 'SA', parent: 'Asia' },
  { label: 'Senegal', value: 'SN', parent: 'Africa' },
  { label: 'Serbia', value: 'RS', parent: 'Europe' },
  { label: 'Serbia', value: 'RS', parent: 'Europe' },
  { label: 'Seychelles', value: 'SC', parent: 'Africa' },
  { label: 'Sierra Leone', value: 'SL', parent: 'Africa' },
  { label: 'Singapore', value: 'SG', parent: 'Asia' },
  { label: 'Sint Maarten', value: 'SX', parent: 'Latin America & Caribbean' },
  { label: 'Slovakia', value: 'SK', parent: 'Europe' },
  { label: 'Slovenia', value: 'SI', parent: 'Europe' },
  { label: 'Solomon Islands', value: 'SB', parent: 'Oceania' },
  { label: 'Somalia', value: 'SO', parent: 'Africa' },
  { label: 'South Africa', value: 'ZA', parent: 'Africa' },
  { label: 'South Sudan', value: 'SS', parent: 'Africa' },
  { label: 'Spain', value: 'ES', parent: 'Europe' },
  { label: 'Sri Lanka', value: 'LK', parent: 'Asia' },
  { label: 'Sudan', value: 'SD', parent: 'Africa' },
  { label: 'Suriname', value: 'SR', parent: 'Latin America & Caribbean' },
  { label: 'Svalbard and Jan Mayen', value: 'SJ', parent: 'Europe' },
  { label: 'Sweden', value: 'SE', parent: 'Europe' },
  { label: 'Switzerland', value: 'CH', parent: 'Europe' },
  { label: 'Syrian Arab Republic', value: 'SY', parent: 'Asia' },
  { label: 'Taiwan', value: 'TW', parent: 'Asia' },
  { label: 'Tajikistan', value: 'TJ', parent: 'Asia' },
  { label: 'Tanzania, the United Republic of', value: 'TZ', parent: 'Africa' },
  { label: 'Thailand', value: 'TH', parent: 'Asia' },
  { label: 'Timor-Leste', value: 'TL', parent: 'Asia' },
  { label: 'Togo', value: 'TG', parent: 'Africa' },
  { label: 'Togo', value: 'TG', parent: 'Africa' },
  { label: 'Tonga', value: 'TO', parent: 'Oceania' },
  {
    label: 'Trinidad and Tobago',
    value: 'TT',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Tunisia', value: 'TN', parent: 'Africa' },
  { label: 'Turkey', value: 'TR', parent: 'Asia' },
  { label: 'Turkmenistan', value: 'TM', parent: 'Asia' },
  {
    label: 'Turks and Caicos Islands',
    value: 'TC',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Tuvalu', value: 'TV', parent: 'Oceania' },
  { label: 'Uganda', value: 'UG', parent: 'Africa' },
  { label: 'Ukraine', value: 'UA', parent: 'Europe' },
  { label: 'United Arab Emirates', value: 'AE', parent: 'Asia' },
  { label: 'United Kingdom', value: 'GB', parent: 'Europe' },
  { label: 'United States', value: 'US', parent: 'North America' },
  { label: 'Uruguay', value: 'UY', parent: 'Latin America & Caribbean' },
  { label: 'Uzbekistan', value: 'UZ', parent: 'Asia' },
  { label: 'Vanuatu', value: 'VU', parent: 'Oceania' },
  {
    label: 'Venezuela, Bolivarian Republic of',
    value: 'VE',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Vietnam', value: 'VN', parent: 'Asia' },
  {
    label: 'Virgin Islands (U.S.)',
    value: 'VI',
    parent: 'Latin America & Caribbean',
  },
  {
    label: 'Virgin Islands, British',
    value: 'VG',
    parent: 'Latin America & Caribbean',
  },
  { label: 'Wallis and Futuna', value: 'WF', parent: 'Oceania' },
  { label: 'Western Sahara', value: 'EH', parent: 'Africa' },
  { label: 'Yemen', value: 'YE', parent: 'Asia' },
  { label: 'Zambia', value: 'ZM', parent: 'Africa' },
  { label: 'Zimbabwe', value: 'ZW', parent: 'Africa' },
];

export const EMPLOYEE_RANGES = [
  { label: '1-10', value: '1~10' },
  { label: '11-50', value: '11~50' },
  { label: '51-250', value: '51~250' },
  { label: '251-1K', value: '251~1000' },
  { label: '1K-5K', value: '1001~5000' },
  { label: '5K-10K', value: '5001~10000' },
  { label: '10K-50K', value: '10001~50000' },
  { label: '50K-100K', value: '50001~100000' },
  { label: '100K+', value: '100000~' },
];

// from https://docs.google.com/spreadsheets/d/1LYEqb820SqPxDLOnDC8qxAEqddNaz9RZu6jbyuM7868/edit#gid=1737013508
export const INDUSTRIES = [
  { label: 'Aerospace & Defense', value: 'Aerospace & Defense' },
  { label: 'Air Freight & Logistics', value: 'Air Freight & Logistics' },
  { label: 'Airlines', value: 'Airlines' },
  { label: 'Automotive', value: 'Automotive' },
  { label: 'Banks', value: 'Banks' },
  { label: 'Beverages', value: 'Beverages' },
  { label: 'Biotechnology', value: 'Biotechnology' },
  { label: 'Building Materials', value: 'Building Materials' },
  { label: 'Capital Goods', value: 'Capital Goods' },
  { label: 'Capital Markets', value: 'Capital Markets' },
  { label: 'Chemicals', value: 'Chemicals' },
  {
    label: 'Commercial Services & Supplies',
    value: 'Commercial Services & Supplies',
  },
  { label: 'Communications Equipment', value: 'Communications Equipment' },
  { label: 'Construction & Engineering', value: 'Construction & Engineering' },
  { label: 'Consumer Discretionary', value: 'Consumer Discretionary' },
  { label: 'Consumer Goods', value: 'Consumer Goods' },
  { label: 'Consumer Services', value: 'Consumer Services' },
  { label: 'Consumer Staples', value: 'Consumer Staples' },
  { label: 'Containers & Packaging', value: 'Containers & Packaging' },
  { label: 'Distributors', value: 'Distributors' },
  {
    label: 'Diversified Consumer Services',
    value: 'Diversified Consumer Services',
  },
  {
    label: 'Diversified Financial Services',
    value: 'Diversified Financial Services',
  },
  {
    label: 'Diversified Telecommunication Services',
    value: 'Diversified Telecommunication Services',
  },
  { label: 'Education Services', value: 'Education Services' },
  { label: 'Electric Utilities', value: 'Electric Utilities' },
  { label: 'Electrical Equipment', value: 'Electrical Equipment' },
  {
    label: 'Electronic Equipment, Instruments & Components',
    value: 'Electronic Equipment, Instruments & Components',
  },
  { label: 'Family Services', value: 'Family Services' },
  { label: 'Food & Staples Retailing', value: 'Food & Staples Retailing' },
  { label: 'Food Products', value: 'Food Products' },
  { label: 'Gas Utilities', value: 'Gas Utilities' },
  {
    label: 'Health Care Equipment & Supplies',
    value: 'Health Care Equipment & Supplies',
  },
  {
    label: 'Health Care Providers & Services',
    value: 'Health Care Providers & Services',
  },
  {
    label: 'Hotels, Restaurants & Leisure',
    value: 'Hotels, Restaurants & Leisure',
  },
  { label: 'Household Durables', value: 'Household Durables' },
  { label: 'Industrial Conglomerates', value: 'Industrial Conglomerates' },
  { label: 'Industrials', value: 'Industrials' },
  { label: 'Insurance', value: 'Insurance' },
  {
    label: 'Internet Software & Services',
    value: 'Internet Software & Services',
  },
  { label: 'IT Services', value: 'IT Services' },
  { label: 'Leisure Products', value: 'Leisure Products' },
  {
    label: 'Life Sciences Tools & Services',
    value: 'Life Sciences Tools & Services',
  },
  { label: 'Machinery', value: 'Machinery' },
  { label: 'Marine', value: 'Marine' },
  { label: 'Media', value: 'Media' },
  { label: 'Metals & Mining', value: 'Metals & Mining' },
  { label: 'Paper & Forest Products', value: 'Paper & Forest Products' },
  { label: 'Personal Products', value: 'Personal Products' },
  { label: 'Pharmaceuticals', value: 'Pharmaceuticals' },
  { label: 'Professional Services', value: 'Professional Services' },
  { label: 'Real Estate', value: 'Real Estate' },
  { label: 'Renewable Electricity', value: 'Renewable Electricity' },
  { label: 'Retailing', value: 'Retailing' },
  { label: 'Road & Rail', value: 'Road & Rail' },
  {
    label: 'Semiconductors & Semiconductor Equipment',
    value: 'Semiconductors & Semiconductor Equipment',
  },
  {
    label: 'Specialized Consumer Services',
    value: 'Specialized Consumer Services',
  },
  { label: 'Specialty Retail', value: 'Specialty Retail' },
  {
    label: 'Technology Hardware, Storage & Peripherals',
    value: 'Technology Hardware, Storage & Peripherals',
  },
  {
    label: 'Textiles, Apparel & Luxury Goods',
    value: 'Textiles, Apparel & Luxury Goods',
  },
  { label: 'Tobacco', value: 'Tobacco' },
  {
    label: 'Trading Companies & Distributors',
    value: 'Trading Companies & Distributors',
  },
  { label: 'Transportation', value: 'Transportation' },
  { label: 'Utilities', value: 'Utilities' },
  {
    label: 'Wireless Telecommunication Services',
    value: 'Wireless Telecommunication Services',
  },
];

// Combined with COMPANY_TYPES to query tags
export const BUSINESS_MODELS = [
  {
    label: 'B2B',
    value: 'B2B',
  },
  {
    label: 'B2C',
    value: 'B2C',
  },
];

// Combined with BUSINESS_MODELS to query tags
export const COMPANY_TYPES = [
  { label: 'Education', value: 'education' },
  { label: 'Government', value: 'government' },
  { label: 'Non-profit', value: 'nonprofit' },
  { label: 'Private', value: 'private' },
  { label: 'Public', value: 'public' },
];

export const RAISED_RANGES = [
  { label: '$0-$1M', value: '0~1000000' },
  { label: '$1M-$10M', value: '1000001~10000000' },
  { label: '$10M-$50M', value: '10000001~50000000' },
  { label: '$50M-$100M', value: '50000001~100000000' },
  { label: '$100M+', value: '100000001~' },
];

// from https://docs.google.com/spreadsheets/d/1LYEqb820SqPxDLOnDC8qxAEqddNaz9RZu6jbyuM7868/edit#gid=876271086
export const TECH = [
  { label: '1&1 Hosting', value: '1_and_1_hosting', parent: 'Web Hosting' },
  { label: '3d Cart', value: '3d_cart', parent: 'eCommerce' },
  { label: 'Acquia', value: 'acquia', parent: 'Content Management System' },
  { label: 'Acquisio', value: 'acquisio', parent: 'Advertising' },
  { label: 'Act On', value: 'act_on', parent: 'Marketing Automation' },
  {
    label: 'Action Network',
    value: 'action_network',
    parent: 'Email Delivery Service',
  },
  {
    label: 'Active Demand',
    value: 'active_demand',
    parent: 'Marketing Automation',
  },
  {
    label: 'Activecampaign',
    value: 'activecampaign',
    parent: 'Marketing Automation',
  },
  { label: 'Add To Any', value: 'add_to_any', parent: 'Social Sharing' },
  {
    label: 'Adform Advertiser',
    value: 'adform_advertiser',
    parent: 'Advertising',
  },
  { label: 'Admeld', value: 'admeld', parent: 'Advertising' },
  {
    label: 'Adobe Business Catalyst',
    value: 'adobe_business_catalyst',
    parent: 'Content Management System',
  },
  { label: 'Adobe Connect', value: 'adobe_connect', parent: 'Live Chat' },
  {
    label: 'Adobe Dynamic Tag Management',
    value: 'adobe_dynamic_tag_management',
    parent: 'Tag Management',
  },
  {
    label: 'Adobe Experience Manager',
    value: 'adobe_experience_manager',
    parent: 'Content Management System',
  },
  {
    label: 'Adobe Marketing Cloud',
    value: 'adobe_marketing_cloud',
    parent: 'Marketing Automation',
  },
  { label: 'ADP', value: 'adp', parent: 'Human Capital Management' },
  { label: 'AdRoll', value: 'adroll', parent: 'Advertising' },
  { label: 'Adscale', value: 'adscale', parent: 'Advertising' },
  {
    label: 'Aggregate Knowledge',
    value: 'aggregate_knowledge',
    parent: 'Data Management',
  },
  { label: 'Airbrake', value: 'airbrake', parent: 'Monitoring' },
  { label: 'Akamai', value: 'akamai', parent: 'Cloud Computing Services' },
  { label: 'Akamai DNS', value: 'akamai_dns', parent: 'DNS' },
  { label: 'Alexa', value: 'alexa', parent: 'Conversion Optimization' },
  { label: 'Algolia', value: 'algolia', parent: 'Site Search' },
  { label: 'Alteryx', value: 'alteryx', parent: 'Analytics' },
  { label: 'Altocloud', value: 'altocloud', parent: 'Analytics' },
  {
    label: 'Amazon Associates',
    value: 'amazon_associates',
    parent: 'Advertising',
  },
  { label: 'Amazon Payments', value: 'amazon_payments', parent: 'Payment' },
  {
    label: 'Amazon S3',
    value: 'amazon_s3',
    parent: 'Cloud Computing Services',
  },
  {
    label: 'Amazon Simple Email Service',
    value: 'amazon_ses',
    parent: 'Email Delivery Service',
  },
  { label: 'amCharts', value: 'amcharts', parent: 'Data Visualization' },
  { label: 'Amplitude', value: 'amplitude', parent: 'Analytics' },
  { label: 'Android', value: 'android', parent: 'Operating System' },
  { label: 'Apache', value: 'apache', parent: 'Web Servers' },
  { label: 'Apache Apex', value: 'apache_apex', parent: 'Data Processing' },
  { label: 'Apache Cassandra', value: 'apache_cassandra', parent: 'Database' },
  { label: 'Apache Hadoop', value: 'apache_hadoop', parent: 'Data Processing' },
  {
    label: 'Apache Http Server',
    value: 'apache_http_server',
    parent: 'Web Servers',
  },
  { label: 'Apache Kafka', value: 'apache_kafka', parent: 'Data Processing' },
  {
    label: 'Apache Maven',
    value: 'apache_maven',
    parent: 'Project Management Software',
  },
  { label: 'Apache Nifi', value: 'apache_nifi', parent: 'Data Processing' },
  { label: 'Apache Spark', value: 'apache_spark', parent: 'Data Processing' },
  { label: 'Apache Storm', value: 'apache_storm', parent: 'Data Processing' },
  { label: 'Apache Tomcat', value: 'apache_tomcat', parent: 'Web Servers' },
  { label: 'App Nexus', value: 'app_nexus', parent: 'Advertising' },
  { label: 'Appboy', value: 'appboy', parent: 'Marketing Automation' },
  { label: 'Appcues', value: 'appcues', parent: 'Conversion Optimization' },
  {
    label: 'AppDynamics',
    value: 'appdynamics',
    parent: 'Website Optimization',
  },
  { label: 'Appier', value: 'appier', parent: 'Marketing Automation' },
  { label: 'Applepay', value: 'applepay', parent: 'Payment' },
  { label: 'Appnexus', value: 'appnexus', parent: 'Advertising' },
  { label: 'Apteligent', value: 'apteligent', parent: 'Monitoring' },
  { label: 'ASP.Net', value: 'asp_net', parent: 'Programming Framework' },
  {
    label: 'Atlassian Confluence',
    value: 'atlassian_confluence',
    parent: 'Productivity',
  },
  { label: 'Atlassian Crowd', value: 'atlassian_crowd', parent: 'Security' },
  {
    label: 'Atlassian Crucible',
    value: 'atlassian_crucible',
    parent: 'Productivity',
  },
  {
    label: 'Atlassian Fisheye',
    value: 'atlassian_fisheye',
    parent: 'Productivity',
  },
  {
    label: 'Atlassian Jira',
    value: 'atlassian_jira',
    parent: 'Project Management Software',
  },
  { label: 'Attraqt', value: 'attraqt', parent: 'Conversion Optimization' },
  { label: 'Attribution', value: 'attribution', parent: 'Analytics' },
  { label: 'Authorizenet', value: 'authorizenet', parent: 'Payment' },
  { label: 'Autopilot', value: 'autopilot', parent: 'Marketing Automation' },
  { label: 'Aweber', value: 'aweber', parent: 'Marketing Automation' },
  { label: 'AWS Cloudwatch', value: 'aws_cloudwatch', parent: 'Monitoring' },
  { label: 'AWS Dynamodb', value: 'aws_dynamodb', parent: 'Database' },
  {
    label: 'Amazon Web Services',
    value: 'aws_ec2',
    parent: 'Cloud Computing Services',
  },
  { label: 'AWS IAM', value: 'aws_iam', parent: 'Security' },
  { label: 'AWS Kinesis', value: 'aws_kinesis', parent: 'Data Processing' },
  { label: 'AWS Lambda', value: 'aws_lambda', parent: 'Data Processing' },
  { label: 'AWS Redshift', value: 'aws_redshift', parent: 'Data Processing' },
  { label: 'Route 53', value: 'aws_route_53', parent: 'DNS' },
  { label: 'Baidu Analytics', value: 'baidu_analytics', parent: 'Analytics' },
  { label: 'Bamboohr', value: 'bamboohr', parent: 'Human Capital Management' },
  { label: 'Basecamp', value: 'basecamp', parent: 'Productivity' },
  {
    label: 'Bazaarvoice',
    value: 'bazaarvoice',
    parent: 'Conversion Optimization',
  },
  {
    label: 'Benchmarkemail',
    value: 'benchmarkemail',
    parent: 'Marketing Automation',
  },
  { label: 'Big Cartel', value: 'big_cartel', parent: 'eCommerce' },
  { label: 'Bigcommerce', value: 'bigcommerce', parent: 'eCommerce' },
  { label: 'Bing Ads', value: 'bing_ads', parent: 'Advertising' },
  { label: 'Bing Advertiser', value: 'bing_advertiser', parent: 'Advertising' },
  { label: 'Bing Maps', value: 'bing_maps', parent: 'Geolocation' },
  {
    label: 'Bloomreach',
    value: 'bloomreach',
    parent: 'Content Management System',
  },
  {
    label: 'Bluehost Hosting',
    value: 'bluehost_hosting',
    parent: 'Web Hosting',
  },
  { label: 'Bluekai', value: 'bluekai', parent: 'Data Management' },
  { label: 'Bold Commerce', value: 'bold_commerce', parent: 'eCommerce' },
  { label: 'Braintree', value: 'braintree', parent: 'Payment' },
  { label: 'Branch', value: 'branch', parent: 'Website Optimization' },
  {
    label: 'Image and Video Services',
    value: 'brightcove',
    parent: 'Image and Video Services',
  },
  { label: 'Bronto', value: 'bronto', parent: 'Marketing Automation' },
  { label: 'Bug Herd', value: 'bug_herd', parent: 'Monitoring' },
  { label: 'Bugsnag', value: 'bugsnag', parent: 'Monitoring' },
  { label: 'C3 Metrics', value: 'c3_metrics', parent: 'Advertising' },
  { label: 'Callrail', value: 'callrail', parent: 'Sales Productivity' },
  { label: 'Calq', value: 'calq', parent: 'Analytics' },
  {
    label: 'Campaignmonitor',
    value: 'campaignmonitor',
    parent: 'Marketing Automation',
  },
  { label: 'Castle', value: 'castle', parent: 'Authentication Services' },
  { label: 'CentOS', value: 'centos', parent: 'Operating System' },
  { label: 'Ceridian', value: 'ceridian', parent: 'Human Capital Management' },
  { label: 'Chargify', value: 'chargify', parent: 'Payment' },
  { label: 'Chart Beat', value: 'chart_beat', parent: 'Analytics' },
  { label: 'Chartio', value: 'chartio', parent: 'Data Visualization' },
  { label: 'Chatlio', value: 'chatlio', parent: 'Live Chat' },
  { label: 'Chownow', value: 'chownow', parent: 'Bookings and Reservations' },
  { label: 'Cision', value: 'cision', parent: 'Marketing Automation' },
  { label: 'CJ Affiliate', value: 'cj_affiliate', parent: 'Advertising' },
  { label: 'Classy', value: 'classy', parent: 'Content Management System' },
  { label: 'Clearslide', value: 'clearslide', parent: 'Sales Productivity' },
  {
    label: 'ClickFunnels',
    value: 'clickfunnels',
    parent: 'Conversion Optimization',
  },
  { label: 'Clicktale', value: 'clicktale', parent: 'Analytics' },
  { label: 'Clicky', value: 'clicky', parent: 'Analytics' },
  { label: 'Cloud Flare', value: 'cloud_flare', parent: 'DNS' },
  { label: 'Cloudera', value: 'cloudera', parent: 'Data Processing' },
  {
    label: 'Cloudinary',
    value: 'cloudinary',
    parent: 'Image and Video Services',
  },
  { label: 'Cludo', value: 'cludo', parent: 'Site Search' },
  {
    label: 'Commerce Sciences',
    value: 'commerce_sciences',
    parent: 'Conversion Optimization',
  },
  { label: 'Confluence', value: 'confluence', parent: 'Productivity' },
  {
    label: 'Constant Contact',
    value: 'constant_contact',
    parent: 'Marketing Automation',
  },
  {
    label: 'Contentful',
    value: 'contentful',
    parent: 'Content Management System',
  },
  { label: 'Contently', value: 'contently', parent: 'Marketing Automation' },
  { label: 'Conversio', value: 'conversio', parent: 'Marketing Automation' },
  {
    label: 'Convert Kit',
    value: 'convert_kit',
    parent: 'Marketing Automation',
  },
  { label: 'Convertro', value: 'convertro', parent: 'Conversion Optimization' },
  { label: 'Convio', value: 'convio', parent: 'CRM' },
  { label: 'Couchbase', value: 'couchbase', parent: 'Database' },
  { label: 'Couchdb', value: 'couchdb', parent: 'Database' },
  { label: 'Coveo', value: 'coveo', parent: 'Site Search' },
  { label: 'Crazy Egg', value: 'crazy_egg', parent: 'Analytics' },
  { label: 'Criteo', value: 'criteo', parent: 'Advertising' },
  { label: 'Crowdskout', value: 'crowdskout', parent: 'CRM' },
  {
    label: 'Customer.io',
    value: 'customer_io',
    parent: 'Marketing Automation',
  },
  { label: 'Cyberark', value: 'cyberark', parent: 'Security' },
  { label: 'Cybersource', value: 'cybersource', parent: 'Payment' },
  {
    label: 'Dailymotion',
    value: 'dailymotion',
    parent: 'Image and Video Services',
  },
  { label: 'Datadog', value: 'datadog', parent: 'Monitoring' },
  { label: 'Db2', value: 'db2', parent: 'Database' },
  { label: 'DC Storm', value: 'dc_storm', parent: 'Marketing Automation' },
  { label: 'Debian', value: 'debian', parent: 'Operating System' },
  {
    label: 'Dell Boomi Atomsphere',
    value: 'dell_boomi_atomsphere',
    parent: 'Data Management',
  },
  {
    label: 'Demandbase',
    value: 'demandbase',
    parent: 'Account Based Marketing',
  },
  { label: 'Demandware', value: 'demandware', parent: 'eCommerce' },
  {
    label: 'Demandware Analytics',
    value: 'demandware_analytics',
    parent: 'Analytics',
  },
  {
    label: 'Digital Ocean',
    value: 'digital_ocean',
    parent: 'Cloud Computing Services',
  },
  { label: 'Disqus', value: 'disqus', parent: 'User Engagement' },
  { label: 'Django', value: 'django', parent: 'Programming Framework' },
  { label: 'DNS Made Easy', value: 'dns_made_easy', parent: 'DNS' },
  { label: 'Dotmailer', value: 'dotmailer', parent: 'Marketing Automation' },
  { label: 'DoubleClick Ads', value: 'double_click', parent: 'Advertising' },
  {
    label: 'DoubleClick Advertiser',
    value: 'double_click_advertiser',
    parent: 'Advertising',
  },
  {
    label: 'DreamHost Hosting',
    value: 'dreamhost_hosting',
    parent: 'Web Hosting',
  },
  { label: 'Drift', value: 'drift', parent: 'Live Chat' },
  { label: 'Drip', value: 'drip', parent: 'Marketing Automation' },
  { label: 'Dropbox', value: 'dropbox', parent: 'Productivity' },
  { label: 'Drupal', value: 'drupal', parent: 'Content Management System' },
  { label: 'Drupal Commerce', value: 'drupal_commerce', parent: 'eCommerce' },
  { label: 'Dstillery', value: 'dstillery', parent: 'Advertising' },
  { label: 'Dwolla', value: 'dwolla', parent: 'Payment' },
  { label: 'Dyn DNS', value: 'dyn_dns', parent: 'DNS' },
  {
    label: 'Dynamic Yield',
    value: 'dynamic_yield',
    parent: 'Website Optimization',
  },
  { label: 'Dynatrace', value: 'dynatrace', parent: 'Website Optimization' },
  { label: 'Ecwid', value: 'ecwid', parent: 'eCommerce' },
  {
    label: 'ElasticEmail',
    value: 'elasticemail',
    parent: 'Email Delivery Service',
  },
  { label: 'Elevio', value: 'elevio', parent: 'Customer Support' },
  { label: 'Eloqua', value: 'eloqua', parent: 'Marketing Automation' },
  { label: 'Emarsys', value: 'emarsys', parent: 'Marketing Automation' },
  { label: 'Ember', value: 'ember', parent: 'Programming Framework' },
  { label: 'Emma', value: 'emma', parent: 'Marketing Automation' },
  { label: 'Engagio', value: 'engagio', parent: 'Account Based Marketing' },
  { label: 'Entrust', value: 'entrust', parent: 'Security' },
  { label: 'Errorception', value: 'errorception', parent: 'Monitoring' },
  { label: 'Express', value: 'express', parent: 'Programming Framework' },
  {
    label: 'Facebook Advertiser',
    value: 'facebook_advertiser',
    parent: 'Advertising',
  },
  { label: 'Facebook Beacon', value: 'facebook_beacon', parent: 'Geolocation' },
  {
    label: 'Facebook Comments',
    value: 'facebook_comments',
    parent: 'User Engagement',
  },
  {
    label: 'Facebook Connect',
    value: 'facebook_connect',
    parent: 'Authentication Services',
  },
  {
    label: 'Facebook Conversion Tracking',
    value: 'facebook_conversion_tracking',
    parent: 'Conversion Optimization',
  },
  {
    label: 'Facebook Like Button',
    value: 'facebook_like_button',
    parent: 'User Engagement',
  },
  {
    label: 'Facebook Social Plugins',
    value: 'facebook_social_plugins',
    parent: 'Social Sharing',
  },
  {
    label: 'Facebook Workplace',
    value: 'facebook_workplace',
    parent: 'Productivity',
  },
  { label: 'Factset', value: 'factset', parent: 'Accounting And Finance' },
  { label: 'Fedora', value: 'fedora', parent: 'Operating System' },
  { label: 'Filemaker Pro', value: 'filemaker_pro', parent: 'Database' },
  {
    label: 'Flexera Software',
    value: 'flexera_software',
    parent: 'Accounting And Finance',
  },
  {
    label: 'Flowplayer',
    value: 'flowplayer',
    parent: 'Image and Video Services',
  },
  { label: 'Formstack', value: 'formstack', parent: 'Form Builder' },
  { label: 'FreeBSD', value: 'freebsd', parent: 'Operating System' },
  { label: 'Freshdesk', value: 'freshdesk', parent: 'Customer Support' },
  {
    label: 'Fullcontact',
    value: 'fullcontact',
    parent: 'Data Enrichment Services',
  },
  { label: 'Fullstory', value: 'fullstory', parent: 'Website Optimization' },
  {
    label: 'FusionCharts',
    value: 'fusioncharts',
    parent: 'Data Visualization',
  },
  { label: 'Gauges', value: 'gauges', parent: 'Analytics' },
  {
    label: 'Get Response',
    value: 'get_response',
    parent: 'Marketing Automation',
  },
  {
    label: 'Get Satisfaction',
    value: 'get_satisfaction',
    parent: 'User Engagement',
  },
  { label: 'Gigya', value: 'gigya', parent: 'Security' },
  { label: 'Github', value: 'github', parent: 'Productivity' },
  { label: 'Gitlab', value: 'gitlab', parent: 'Productivity' },
  { label: 'Go Squared', value: 'go_squared', parent: 'Live Chat' },
  { label: 'Gocardless', value: 'gocardless', parent: 'Payment' },
  { label: 'GoDaddy Hosting', value: 'godaddy_hosting', parent: 'Web Hosting' },
  {
    label: 'Godaddy Nameserver',
    value: 'godaddy_nameserver',
    parent: 'Web Hosting',
  },
  { label: 'Goldengate', value: 'goldengate', parent: 'Data Management' },
  { label: 'Goldmine', value: 'goldmine', parent: 'CRM' },
  { label: 'Google Adsense', value: 'google_adsense', parent: 'Advertising' },
  { label: 'Google Adwords', value: 'google_adwords', parent: 'Advertising' },
  {
    label: 'Google Affiliate Network',
    value: 'google_affiliate_network',
    parent: 'Advertising',
  },
  { label: 'Google Analytics', value: 'google_analytics', parent: 'Analytics' },
  { label: 'Google Apps', value: 'google_apps', parent: 'Productivity' },
  {
    label: 'Google Charts',
    value: 'google_charts',
    parent: 'Data Visualization',
  },
  {
    label: 'Google Cloud',
    value: 'google_cloud',
    parent: 'Cloud Computing Services',
  },
  { label: 'Google Forms', value: 'google_forms', parent: 'Form Builder' },
  { label: 'Google Maps', value: 'google_maps', parent: 'Geolocation' },
  { label: 'Google_places', value: 'google_places', parent: 'Geolocation' },
  {
    label: 'Google_remarketing',
    value: 'google_remarketing',
    parent: 'Advertising',
  },
  {
    label: 'Google Search Appliance',
    value: 'google_search_appliance',
    parent: 'Marketing Automation',
  },
  {
    label: 'Google Tag Manager',
    value: 'google_tag_manager',
    parent: 'Tag Management',
  },
  {
    label: 'Google Website Optimizer',
    value: 'google_website_optimizer',
    parent: 'Website Optimization',
  },
  {
    label: 'Google Widgets',
    value: 'google_widgets',
    parent: 'Social Sharing',
  },
  { label: 'Gotomeeting', value: 'gotomeeting', parent: 'Productivity' },
  { label: 'Grafana', value: 'grafana', parent: 'Monitoring' },
  { label: 'GraphIQ', value: 'graphiq', parent: 'Data Visualization' },
  { label: 'Gravity Forms', value: 'gravity_forms', parent: 'Form Builder' },
  {
    label: 'Greenhouse',
    value: 'greenhouse',
    parent: 'Applicant Tracking System',
  },
  { label: 'GroupBy', value: 'groupby', parent: 'eCommerce' },
  { label: 'Hbase', value: 'hbase', parent: 'Database' },
  { label: 'Heap', value: 'heap', parent: 'Analytics' },
  { label: 'Hello Bar', value: 'hello_bar', parent: 'Conversion Optimization' },
  { label: 'Help Scout', value: 'help_scout', parent: 'Customer Support' },
  { label: 'Heroku', value: 'heroku', parent: 'Web Hosting' },
  { label: 'Highcharts', value: 'highcharts', parent: 'Data Visualization' },
  { label: 'Hive', value: 'hive', parent: 'Database' },
  { label: 'Hootsuite', value: 'hootsuite', parent: 'Marketing Automation' },
  { label: 'Hotjar', value: 'hotjar', parent: 'Website Optimization' },
  { label: 'Hoverowl', value: 'hoverowl', parent: 'Analytics' },
  { label: 'HP Servers', value: 'hp_servers', parent: 'Web Servers' },
  { label: 'HubSpot', value: 'hubspot', parent: 'Marketing Automation' },
  { label: 'IBM Cognos', value: 'ibm_cognos', parent: 'Analytics' },
  {
    label: 'IBM Infosphere',
    value: 'ibm_infosphere',
    parent: 'Data Management',
  },
  {
    label: 'IBM Infosphere Datastage',
    value: 'ibm_infosphere_datastage',
    parent: 'Data Management',
  },
  {
    label: 'IBM Lotus Domino',
    value: 'ibm_lotus_domino',
    parent: 'Productivity',
  },
  {
    label: 'IBM Lotus Notes',
    value: 'ibm_lotus_notes',
    parent: 'Productivity',
  },
  { label: 'IBM Websphere', value: 'ibm_websphere', parent: 'Web Servers' },
  {
    label: 'IBM Websphere Commerce',
    value: 'ibm_websphere_commerce',
    parent: 'eCommerce',
  },
  { label: 'Icims', value: 'icims', parent: 'Applicant Tracking System' },
  { label: 'Indicative', value: 'indicative', parent: 'Analytics' },
  {
    label: 'Influitive',
    value: 'influitive',
    parent: 'Conversion Optimization',
  },
  { label: 'Informatica', value: 'informatica', parent: 'Data Management' },
  {
    label: 'Information Builders',
    value: 'information_builders',
    parent: 'Analytics',
  },
  {
    label: 'Infusionsoft',
    value: 'infusionsoft',
    parent: 'Marketing Automation',
  },
  {
    label: 'Inside Sales',
    value: 'inside_sales',
    parent: 'Sales Productivity',
  },
  { label: 'Inspectlet', value: 'inspectlet', parent: 'Website Optimization' },
  { label: 'Instagram', value: 'instagram', parent: 'Social Sharing' },
  {
    label: 'Instagram Links',
    value: 'instagram_links',
    parent: 'Social Sharing',
  },
  {
    label: 'Instart Logic',
    value: 'instart_logic',
    parent: 'Cloud Computing Services',
  },
  {
    label: 'Intense Debate',
    value: 'intense_debate',
    parent: 'User Engagement',
  },
  { label: 'Intercom', value: 'intercom', parent: 'Live Chat' },
  { label: 'Interspire', value: 'interspire', parent: 'Marketing Automation' },
  { label: 'Invoca', value: 'invoca', parent: 'Marketing Automation' },
  { label: 'ios', value: 'ios', parent: 'Programming Framework' },
  {
    label: 'Iponweb Bidswitch',
    value: 'iponweb_bidswitch',
    parent: 'Advertising',
  },
  { label: 'Iterable', value: 'iterable', parent: 'Marketing Automation' },
  { label: 'Jabmo', value: 'jabmo', parent: 'Account Based Marketing' },
  { label: 'Janrain', value: 'janrain', parent: 'Security' },
  { label: 'Jaspersoft', value: 'jaspersoft', parent: 'Data Visualization' },
  { label: 'Java', value: 'java', parent: 'Programming Framework' },
  {
    label: 'Jha Payment Solutions',
    value: 'jha_payment_solutions',
    parent: 'Payment',
  },
  { label: 'Jobvite', value: 'jobvite', parent: 'Applicant Tracking System' },
  { label: 'Joomla', value: 'joomla', parent: 'Content Management System' },
  { label: 'Justuno', value: 'justuno', parent: 'Conversion Optimization' },
  {
    label: 'Jw Player',
    value: 'jw_player',
    parent: 'Image and Video Services',
  },
  { label: 'Kaltura', value: 'kaltura', parent: 'Image and Video Services' },
  { label: 'Kapost', value: 'kapost', parent: 'Marketing Automation' },
  { label: 'Keen IO', value: 'keen_io', parent: 'Analytics' },
  { label: 'Kissmetrics', value: 'kiss_metrics', parent: 'Analytics' },
  { label: 'Klaviyo', value: 'klaviyo', parent: 'Marketing Automation' },
  { label: 'Klevu', value: 'klevu', parent: 'eCommerce' },
  { label: 'Knowtify', value: 'knowtify', parent: 'Marketing Automation' },
  { label: 'Kronos', value: 'kronos', parent: 'Human Capital Management' },
  { label: 'Lawpay', value: 'lawpay', parent: 'Payment' },
  { label: 'Lead Dyno', value: 'lead_dyno', parent: 'Advertising' },
  { label: 'Lever', value: 'lever', parent: 'Applicant Tracking System' },
  { label: 'Lightspeed', value: 'lightspeed', parent: 'eCommerce' },
  {
    label: 'LinkedIn Advertiser',
    value: 'linked_in_advertiser',
    parent: 'Advertising',
  },
  { label: 'Linkwithin', value: 'linkwithin', parent: 'Website Optimization' },
  { label: 'Linode Hosting', value: 'linode_hosting', parent: 'Web Hosting' },
  { label: 'Litespeed', value: 'litespeed', parent: 'Web Servers' },
  { label: 'Live Chat', value: 'live_chat', parent: 'Live Chat' },
  { label: 'Livefyre', value: 'livefyre', parent: 'User Engagement' },
  { label: 'Liveramp', value: 'liveramp', parent: 'Data Enrichment Services' },
  { label: 'LKQD', value: 'lkqd', parent: 'Image and Video Services' },
  { label: 'Localytics', value: 'localytics', parent: 'Analytics' },
  { label: 'Logrocket', value: 'logrocket', parent: 'Monitoring' },
  { label: 'Looker', value: 'looker', parent: 'Data Visualization' },
  {
    label: 'Lucky Orange',
    value: 'lucky_orange',
    parent: 'Website Optimization',
  },
  { label: 'Mad Kudu', value: 'mad_kudu', parent: 'Marketing Automation' },
  {
    label: 'Madison Logic',
    value: 'madison_logic',
    parent: 'Account Based Marketing',
  },
  { label: 'Magento', value: 'magento', parent: 'eCommerce' },
  {
    label: 'Magento Enterprise',
    value: 'magento_enterprise',
    parent: 'eCommerce',
  },
  { label: 'Magento V1', value: 'magento_v1', parent: 'eCommerce' },
  { label: 'Magento V2', value: 'magento_v2', parent: 'eCommerce' },
  { label: 'Mailchimp', value: 'mailchimp', parent: 'Email Delivery Service' },
  { label: 'Mailer Lite', value: 'mailerlite', parent: 'Marketing Automation' },
  { label: 'Mailgun', value: 'mailgun', parent: 'Email Delivery Service' },
  { label: 'Mailjet', value: 'mailjet', parent: 'Email Delivery Service' },
  { label: 'Mandrill', value: 'mandrill', parent: 'Email Delivery Service' },
  { label: 'Marchex', value: 'marchex', parent: 'Marketing Automation' },
  { label: 'Marin', value: 'marin', parent: 'Advertising' },
  { label: 'Marketo', value: 'marketo', parent: 'Marketing Automation' },
  { label: 'Matomo', value: 'matomo', parent: 'Analytics' },
  {
    label: 'Mavenlink',
    value: 'mavenlink',
    parent: 'Project Management Software',
  },
  { label: 'Maxmind', value: 'maxmind', parent: 'Geolocation' },
  { label: 'Medallia', value: 'medallia', parent: 'Survey' },
  { label: 'Media.net', value: 'media.net', parent: 'Advertising' },
  { label: 'Mediamath', value: 'mediamath', parent: 'Advertising' },
  { label: 'Meltwater', value: 'meltwater', parent: 'Marketing Automation' },
  {
    label: 'Microsoft Azure',
    value: 'microsoft_azure',
    parent: 'Cloud Computing Services',
  },
  { label: 'Microsoft Dynamics', value: 'microsoft_dynamics', parent: 'CRM' },
  {
    label: 'Microsoft Exchange Online',
    value: 'microsoft_exchange_online',
    parent: 'Email Hosting Service',
  },
  {
    label: 'Microsoft Office 365',
    value: 'microsoft_office_365',
    parent: 'Productivity',
  },
  {
    label: 'Microsoft Power BI',
    value: 'microsoft_power_bi',
    parent: 'Data Visualization',
  },
  {
    label: 'Microsoft Project',
    value: 'microsoft_project',
    parent: 'Productivity',
  },
  {
    label: 'Microsoft Sql Server',
    value: 'microsoft_sql_server',
    parent: 'Data Management',
  },
  {
    label: 'Microsoft Team Foundation Server',
    value: 'microsoft_team_foundation_server',
    parent: 'Project Management Software',
  },
  {
    label: 'Microsoft Teams',
    value: 'microsoft_teams',
    parent: 'Productivity',
  },
  { label: 'Microstrategy', value: 'microstrategy', parent: 'Analytics' },
  { label: 'Mindbody', value: 'mindbody', parent: 'Bookings and Reservations' },
  { label: 'Mixpanel', value: 'mixpanel', parent: 'Analytics' },
  { label: 'Mode', value: 'mode', parent: 'Analytics' },
  { label: 'Mongodb', value: 'mongodb', parent: 'Database' },
  { label: 'Monstercommerce', value: 'monstercommerce', parent: 'eCommerce' },
  { label: 'MoonClerk', value: 'moonclerk', parent: 'Payment' },
  { label: 'Mouseflow', value: 'mouseflow', parent: 'Website Optimization' },
  { label: 'Mousestats', value: 'mousestats', parent: 'Website Optimization' },
  { label: 'mrp', value: 'mrp', parent: 'Marketing Automation' },
  {
    label: 'My Site Auditor',
    value: 'my_site_auditor',
    parent: 'Website Optimization',
  },
  { label: 'Mysql', value: 'mysql', parent: 'Database' },
  { label: 'Namecheap Dns', value: 'namecheap_dns', parent: 'DNS' },
  {
    label: 'NationBuilder',
    value: 'nation_builder',
    parent: 'Content Management System',
  },
  { label: 'Ncr Retail', value: 'ncr_retail', parent: 'eCommerce' },
  { label: 'Neo4J', value: 'neo4j', parent: 'Database' },
  { label: 'Netsuite', value: 'netsuite', parent: 'Business Management' },
  { label: 'Netsuite CRM', value: 'netsuite_crm', parent: 'CRM' },
  {
    label: 'Netsuite Suitecommerce',
    value: 'netsuite_suitecommerce',
    parent: 'eCommerce',
  },
  {
    label: 'Neustar Ad Advisor',
    value: 'neustar_ad_advisor',
    parent: 'Advertising',
  },
  { label: 'New Relic', value: 'new_relic', parent: 'Monitoring' },
  { label: 'Nextable', value: 'nextable', parent: 'Bookings and Reservations' },
  { label: 'Nginx', value: 'nginx', parent: 'Web Servers' },
  { label: 'Nimsoft', value: 'nimsoft', parent: 'Monitoring' },
  { label: 'Nopcommerce', value: 'nopcommerce', parent: 'eCommerce' },
  { label: 'Nosto', value: 'nosto', parent: 'eCommerce' },
  { label: 'Ns1', value: 'ns1', parent: 'DNS' },
  { label: 'Okta', value: 'okta', parent: 'Security' },
  { label: 'Olark', value: 'olark', parent: 'Live Chat' },
  {
    label: 'Omniconvert',
    value: 'omniconvert',
    parent: 'Conversion Optimization',
  },
  {
    label: 'Omniture (Adobe Analytics)',
    value: 'omniture_adobe_analytics',
    parent: 'Analytics',
  },
  { label: 'Ooyala', value: 'ooyala', parent: 'Image and Video Services' },
  {
    label: 'Open Table',
    value: 'open_table',
    parent: 'Bookings and Reservations',
  },
  { label: 'OpenID', value: 'openid', parent: 'Security' },
  { label: 'Openx', value: 'openx', parent: 'Advertising' },
  { label: 'Optimizely', value: 'optimizely', parent: 'Website Optimization' },
  { label: 'Optimonk', value: 'optimonk', parent: 'User Engagement' },
  {
    label: 'Oracle Application Server',
    value: 'oracle_application_server',
    parent: 'Web Servers',
  },
  {
    label: 'Oracle Business Intelligence',
    value: 'oracle_business_intelligence',
    parent: 'Analytics',
  },
  {
    label: 'Oracle Cash And Treasury Management',
    value: 'oracle_cash_and_treasury_management',
    parent: 'Accounting And Finance',
  },
  {
    label: 'Oracle Commerce Cloud',
    value: 'oracle_commerce_cloud',
    parent: 'eCommerce',
  },
  { label: 'Oracle CRM', value: 'oracle_crm', parent: 'CRM' },
  {
    label: 'Oracle Data Integrator',
    value: 'oracle_data_integrator',
    parent: 'Data Management',
  },
  { label: 'Oracle Endeca', value: 'oracle_endeca', parent: 'Data Management' },
  { label: 'Oracle Essbase', value: 'oracle_essbase', parent: 'Analytics' },
  {
    label: 'Oracle Fusion',
    value: 'oracle_fusion',
    parent: 'Business Management',
  },
  {
    label: 'Oracle Human Resources',
    value: 'oracle_human_resources',
    parent: 'Human Capital Management',
  },
  {
    label: 'Oracle Hyperion',
    value: 'oracle_hyperion',
    parent: 'Business Management',
  },
  {
    label: 'Oracle Peoplesoft',
    value: 'oracle_peoplesoft',
    parent: 'Business Management',
  },
  { label: 'Oracle Weblogic', value: 'oracle_weblogic', parent: 'Web Servers' },
  { label: 'Oscommerce', value: 'oscommerce', parent: 'eCommerce' },
  { label: 'Outbound', value: 'outbound', parent: 'Marketing Automation' },
  { label: 'Outbrain Ads', value: 'outbrain_ads', parent: 'Advertising' },
  { label: 'Outlook', value: 'outlook', parent: 'Email Hosting Service' },
  { label: 'ownerIQ', value: 'owneriq', parent: 'Advertising' },
  { label: 'Oxid', value: 'oxid', parent: 'eCommerce' },
  { label: 'Pagerduty', value: 'pagerduty', parent: 'Monitoring' },
  { label: 'Panopto', value: 'panopto', parent: 'Image and Video Services' },
  { label: 'Pardot', value: 'pardot', parent: 'Marketing Automation' },
  { label: 'Paychex', value: 'paychex', parent: 'Accounting And Finance' },
  { label: 'PayPal', value: 'paypal', parent: 'Payment' },
  { label: 'Payza', value: 'payza', parent: 'Payment' },
  { label: 'Pentaho', value: 'pentaho', parent: 'Analytics' },
  { label: 'Peoplesoft CRM', value: 'peoplesoft_crm', parent: 'CRM' },
  {
    label: 'Peoplesoft Sales',
    value: 'peoplesoft_sales',
    parent: 'Sales Productivity',
  },
  {
    label: 'Percolate',
    value: 'percolate',
    parent: 'Content Management System',
  },
  {
    label: 'Perfect Audience',
    value: 'perfect_audience',
    parent: 'Advertising',
  },
  {
    label: 'Periscope Data',
    value: 'periscope_data',
    parent: 'Data Visualization',
  },
  { label: 'Picreel', value: 'picreel', parent: 'Conversion Optimization' },
  { label: 'Pingdom', value: 'pingdom', parent: 'Monitoring' },
  { label: 'Pinterest', value: 'pinterest', parent: 'Social Sharing' },
  { label: 'Pipedrive', value: 'pipedrive', parent: 'CRM' },
  {
    label: 'Pivotal Tracker',
    value: 'pivotal_tracker',
    parent: 'Project Management Software',
  },
  { label: 'Piwik', value: 'piwik', parent: 'Analytics' },
  {
    label: 'Planisware',
    value: 'planisware',
    parent: 'Project Management Software',
  },
  { label: 'Playwire', value: 'playwire', parent: 'Image and Video Services' },
  { label: 'Podio', value: 'podio', parent: 'Productivity' },
  { label: 'Postgresql', value: 'postgresql', parent: 'Database' },
  { label: 'Postmark', value: 'postmark', parent: 'Email Delivery Service' },
  { label: 'PowerReviews', value: 'powerreviews', parent: 'User Engagement' },
  { label: 'Presta Shop', value: 'presta_shop', parent: 'eCommerce' },
  { label: 'Privy', value: 'privy', parent: 'Marketing Automation' },
  { label: 'Pubmatic', value: 'pubmatic', parent: 'Advertising' },
  { label: 'Qbrick', value: 'qbrick', parent: 'Image and Video Services' },
  { label: 'Qliktech', value: 'qliktech', parent: 'Analytics' },
  { label: 'Qlikview', value: 'qlikview', parent: 'Analytics' },
  { label: 'Qualaroo', value: 'qualaroo', parent: 'Survey' },
  { label: 'Qualtrics', value: 'qualtrics', parent: 'Survey' },
  { label: 'Quantcast', value: 'quantcast', parent: 'Advertising' },
  { label: 'Qubit', value: 'qubit', parent: 'Website Optimization' },
  { label: 'Quest Foglight', value: 'quest_foglight', parent: 'Monitoring' },
  {
    label: 'Quickbooks',
    value: 'quickbooks',
    parent: 'Accounting And Finance',
  },
  { label: 'Rabbitmq', value: 'rabbitmq', parent: 'Data Management' },
  {
    label: 'Rackspace',
    value: 'rackspace',
    parent: 'Cloud Computing Services',
  },
  {
    label: 'Rackspace Email',
    value: 'rackspace_email',
    parent: 'Email Hosting Service',
  },
  { label: 'Raygun', value: 'raygun', parent: 'Monitoring' },
  { label: 'Recaptcha', value: 'recaptcha', parent: 'Authentication Services' },
  {
    label: 'Recruiterbox',
    value: 'recruiterbox',
    parent: 'Applicant Tracking System',
  },
  { label: 'Recurly', value: 'recurly', parent: 'Payment' },
  { label: 'Red Hat', value: 'red_hat', parent: 'Operating System' },
  { label: 'ReSRCit', value: 'resrcit', parent: 'Image and Video Services' },
  {
    label: 'Resumator',
    value: 'resumator',
    parent: 'Applicant Tracking System',
  },
  { label: 'RetailRocket', value: 'retailrocket', parent: 'eCommerce' },
  { label: 'Rezdy', value: 'rezdy', parent: 'Bookings and Reservations' },
  { label: 'Rezgo', value: 'rezgo', parent: 'Bookings and Reservations' },
  { label: 'Robly', value: 'robly', parent: 'Marketing Automation' },
  { label: 'Rocket Fuel', value: 'rocket_fuel', parent: 'Advertising' },
  { label: 'Rollbar', value: 'rollbar', parent: 'Monitoring' },
  { label: 'RSA SecureID', value: 'rsa_securid', parent: 'Security' },
  { label: 'Rubicon Project', value: 'rubicon_project', parent: 'Advertising' },
  {
    label: 'Ruby On Rails',
    value: 'ruby_on_rails',
    parent: 'Programming Framework',
  },
  {
    label: 'Sage 50Cloud',
    value: 'sage_50cloud',
    parent: 'Accounting And Finance',
  },
  { label: 'Sage CRM', value: 'sage_crm', parent: 'CRM' },
  {
    label: 'Sage Intacct',
    value: 'sage_intacct',
    parent: 'Accounting And Finance',
  },
  { label: 'Sage Pay', value: 'sage_pay', parent: 'Payment' },
  { label: 'Sailpoint', value: 'sailpoint', parent: 'Security' },
  { label: 'Salesforce', value: 'salesforce', parent: 'CRM' },
  {
    label: 'Salesforce Dmp',
    value: 'salesforce_dmp',
    parent: 'Data Management',
  },
  { label: 'SalesLoft', value: 'salesloft', parent: 'Sales Productivity' },
  { label: 'Saleslogix', value: 'saleslogix', parent: 'CRM' },
  {
    label: 'Salesmachine',
    value: 'salesmachine',
    parent: 'Customer Data Platform',
  },
  { label: 'Salsa', value: 'salsa', parent: 'CRM' },
  {
    label: 'SAP Business Objects',
    value: 'sap_business_objects',
    parent: 'Analytics',
  },
  {
    label: 'SAP Concur',
    value: 'sap_concur',
    parent: 'Accounting And Finance',
  },
  { label: 'SAP CRM', value: 'sap_crm', parent: 'CRM' },
  {
    label: 'SAP Crystal Reports',
    value: 'sap_crystal_reports',
    parent: 'Analytics',
  },
  { label: 'SAP Hana', value: 'sap_hana', parent: 'Database' },
  {
    label: 'SAP Human Capital Management',
    value: 'sap_human_capital_management',
    parent: 'Human Capital Management',
  },
  {
    label: 'SAP Hybris Marketing',
    value: 'sap_hybris_marketing',
    parent: 'Marketing Automation',
  },
  {
    label: 'SAP Sales Order Management',
    value: 'sap_sales_order_management',
    parent: 'Accounting And Finance',
  },
  {
    label: 'Sas Data Integration',
    value: 'sas_data_integration',
    parent: 'Data Management',
  },
  { label: 'SAS Enterprise', value: 'sas_enterprise', parent: 'Analytics' },
  { label: 'Satismeter', value: 'satismeter', parent: 'Survey' },
  { label: 'Segment', value: 'segment', parent: 'Customer Data Platform' },
  { label: 'Sendgrid', value: 'sendgrid', parent: 'Email Delivery Service' },
  { label: 'Sendlane', value: 'sendlane', parent: 'Marketing Automation' },
  { label: 'Sentry', value: 'sentry', parent: 'Monitoring' },
  { label: 'Sessioncam', value: 'sessioncam', parent: 'Website Optimization' },
  {
    label: 'Sharepoint',
    value: 'sharepoint',
    parent: 'Content Management System',
  },
  {
    label: 'Sharp Spring',
    value: 'sharp_spring',
    parent: 'Marketing Automation',
  },
  { label: 'Shopify', value: 'shopify', parent: 'eCommerce' },
  { label: 'Shopify Plus', value: 'shopify_plus', parent: 'eCommerce' },
  { label: 'Shopware', value: 'shopware', parent: 'eCommerce' },
  { label: 'Sidecar', value: 'sidecar', parent: 'Marketing Automation' },
  { label: 'Silkroad', value: 'silkroad', parent: 'Human Capital Management' },
  {
    label: 'Simplicant',
    value: 'simplicant',
    parent: 'Applicant Tracking System',
  },
  { label: 'Sitecore', value: 'sitecore', parent: 'eCommerce' },
  {
    label: 'Siteimprove Analytics',
    value: 'siteimprove_analytics',
    parent: 'Analytics',
  },
  { label: '6sense', value: 'sixsense', parent: 'Account Based Marketing' },
  { label: 'Sizmek', value: 'sizmek', parent: 'Advertising' },
  { label: 'Slack', value: 'slack', parent: 'Productivity' },
  { label: 'Smartlook', value: 'smartlook', parent: 'Analytics' },
  {
    label: 'Smartrecruiters',
    value: 'smartrecruiters',
    parent: 'Applicant Tracking System',
  },
  { label: 'Smartsheet', value: 'smartsheet', parent: 'Productivity' },
  { label: 'Smile', value: 'smileio', parent: 'Conversion Optimization' },
  { label: 'Snaplogic', value: 'snaplogic', parent: 'Data Management' },
  { label: 'Snowflake', value: 'snowflake', parent: 'Data Processing' },
  {
    label: 'Snowplow Analytics',
    value: 'snowplow_analytics',
    parent: 'Analytics',
  },
  { label: 'Soasta', value: 'soasta', parent: 'Website Optimization' },
  { label: 'Sociomantic', value: 'sociomantic', parent: 'Advertising' },
  { label: 'Socket.io', value: 'socket_io', parent: 'Programming Framework' },
  {
    label: 'Softlayer Hosting',
    value: 'softlayer_hosting',
    parent: 'Web Hosting',
  },
  { label: 'SpeedCurve', value: 'speedcurve', parent: 'Website Optimization' },
  { label: 'Splunk', value: 'splunk', parent: 'Data Processing' },
  {
    label: 'Squarespace',
    value: 'squarespace',
    parent: 'Content Management System',
  },
  {
    label: 'Squarespace Online Stores',
    value: 'squarespace_online_stores',
    parent: 'eCommerce',
  },
  { label: 'Statcounter', value: 'statcounter', parent: 'Analytics' },
  { label: 'SteelHouse', value: 'steel_house', parent: 'Advertising' },
  { label: 'Stripe', value: 'stripe', parent: 'Payment' },
  {
    label: 'Success Factors',
    value: 'success_factors',
    parent: 'Human Capital Management',
  },
  {
    label: 'Successfactors',
    value: 'successfactors',
    parent: 'Human Capital Management',
  },
  { label: 'SugarCRM', value: 'sugarcrm', parent: 'CRM' },
  { label: 'Sumo', value: 'sumo', parent: 'Conversion Optimization' },
  { label: 'Survey Monkey', value: 'survey_monkey', parent: 'Survey' },
  {
    label: 'Swell Rewards',
    value: 'swell_rewards',
    parent: 'Conversion Optimization',
  },
  { label: 'Swifttype', value: 'swifttype', parent: 'Site Search' },
  { label: 'Sybase', value: 'sybase', parent: 'Database' },
  { label: 'Tableau', value: 'tableau', parent: 'Data Visualization' },
  { label: 'Taboola Ads', value: 'taboola_ads', parent: 'Advertising' },
  { label: 'Talend', value: 'talend', parent: 'Data Management' },
  { label: 'Taleo', value: 'taleo', parent: 'Applicant Tracking System' },
  { label: 'Talkable', value: 'talkable', parent: 'Marketing Automation' },
  { label: 'Tawk', value: 'tawk', parent: 'Live Chat' },
  { label: 'Tealium', value: 'tealium', parent: 'Tag Management' },
  { label: 'Teradata', value: 'teradata', parent: 'Analytics' },
  { label: 'Terminus', value: 'terminus', parent: 'Account Based Marketing' },
  {
    label: 'Thomson Reuters Eikon',
    value: 'thomson_reuters_eikon',
    parent: 'Accounting And Finance',
  },
  { label: 'Tibco Ems', value: 'tibco_ems', parent: 'Data Management' },
  {
    label: 'Tibco Rendezvous',
    value: 'tibco_rendezvous',
    parent: 'Data Management',
  },
  { label: 'Tibco Spotfire', value: 'tibco_spotfire', parent: 'Analytics' },
  {
    label: 'Top Producer',
    value: 'top_producer',
    parent: 'Content Management System',
  },
  { label: 'Totango', value: 'totango', parent: 'Analytics' },
  { label: 'Tout', value: 'tout', parent: 'Image and Video Services' },
  { label: 'Toutapp', value: 'toutapp', parent: 'Marketing Automation' },
  {
    label: 'TowerData',
    value: 'towerdata',
    parent: 'Data Enrichment Services',
  },
  { label: 'Track JS', value: 'track_js', parent: 'Monitoring' },
  { label: 'Trello', value: 'trello', parent: 'Project Management Software' },
  { label: 'Triblio', value: 'triblio', parent: 'Account Based Marketing' },
  {
    label: 'Tripleseat',
    value: 'tripleseat',
    parent: 'Bookings and Reservations',
  },
  { label: 'Trustpilot', value: 'trustpilot', parent: 'User Engagement' },
  { label: 'Turn', value: 'turn', parent: 'Data Management' },
  { label: 'Twilio', value: 'twilio', parent: 'Cloud Computing Services' },
  {
    label: 'Twitter Advertiser',
    value: 'twitter_advertiser',
    parent: 'Advertising',
  },
  { label: 'Twitter Badge', value: 'twitter_badge', parent: 'Social Sharing' },
  {
    label: 'Twitter Button',
    value: 'twitter_button',
    parent: 'Social Sharing',
  },
  { label: 'Typeform', value: 'typeform', parent: 'Form Builder' },
  {
    label: 'Typekit',
    value: 'typekit_by_adobe',
    parent: 'Website Optimization',
  },
  { label: 'Uber Cart', value: 'uber_cart', parent: 'eCommerce' },
  { label: 'Ubuntu', value: 'ubuntu', parent: 'Operating System' },
  { label: 'Ultipro', value: 'ultipro', parent: 'Human Capital Management' },
  { label: 'Unbounce', value: 'unbounce', parent: 'Marketing Automation' },
  { label: 'Unbxd', value: 'unbxd', parent: 'eCommerce' },
  { label: 'Unix', value: 'unix', parent: 'Operating System' },
  { label: 'Uptrends', value: 'uptrends', parent: 'Website Optimization' },
  { label: 'UserVoice', value: 'user_voice', parent: 'Survey' },
  {
    label: 'Vanco Payment Solutions',
    value: 'vanco_payment_solutions',
    parent: 'Payment',
  },
  { label: 'Vero', value: 'vero', parent: 'Marketing Automation' },
  {
    label: 'Verticalresponse',
    value: 'verticalresponse',
    parent: 'Marketing Automation',
  },
  { label: 'Video.js', value: 'videojs', parent: 'Image and Video Services' },
  { label: 'Vidyard', value: 'vidyard', parent: 'Image and Video Services' },
  { label: 'Vimeo', value: 'vimeo', parent: 'Image and Video Services' },
  { label: 'Virtue Mart', value: 'virtue_mart', parent: 'eCommerce' },
  { label: 'Visual IQ', value: 'visual_iq', parent: 'Analytics' },
  {
    label: 'Visual Website Optimizer',
    value: 'visual_website_optimizer',
    parent: 'Website Optimization',
  },
  { label: 'Vmware Server', value: 'vmware_server', parent: 'Web Servers' },
  { label: 'Volusion', value: 'volusion', parent: 'eCommerce' },
  { label: 'Vzaar', value: 'vzaar', parent: 'Image and Video Services' },
  { label: 'WebEngage', value: 'webengage', parent: 'User Engagement' },
  { label: 'Webmethods', value: 'webmethods', parent: 'Data Management' },
  { label: 'Weebly', value: 'weebly', parent: 'Content Management System' },
  { label: 'Weebly Ecommerce', value: 'weebly_ecommerce', parent: 'eCommerce' },
  { label: 'Windows Server', value: 'windows_server', parent: 'Web Servers' },
  { label: 'Wistia', value: 'wistia', parent: 'Image and Video Services' },
  { label: 'Wix Stores', value: 'wix_stores', parent: 'eCommerce' },
  { label: 'Wixstores', value: 'wixstores', parent: 'eCommerce' },
  { label: 'Woo Commerce', value: 'woo_commerce', parent: 'eCommerce' },
  { label: 'Woopra', value: 'woopra', parent: 'Analytics' },
  { label: 'Wootric', value: 'wootric', parent: 'Analytics' },
  {
    label: 'Wordpress',
    value: 'wordpress',
    parent: 'Content Management System',
  },
  { label: 'Workable', value: 'workable', parent: 'Applicant Tracking System' },
  {
    label: 'Workamajig',
    value: 'workamajig',
    parent: 'Project Management Software',
  },
  { label: 'Workday', value: 'workday', parent: 'Human Capital Management' },
  {
    label: 'Wp Engine',
    value: 'wp_engine',
    parent: 'Content Management System',
  },
  { label: 'Wrike', value: 'wrike', parent: 'Project Management Software' },
  { label: 'Wufoo', value: 'wufoo', parent: 'Form Builder' },
  { label: 'xt:Commerce', value: 'xt_commerce', parent: 'eCommerce' },
  { label: 'Yahoo Stores', value: 'yahoo_stores', parent: 'eCommerce' },
  { label: 'Yandex Metrica', value: 'yandex_metrica', parent: 'Analytics' },
  {
    label: 'Yelp Seatme',
    value: 'yelp_seatme',
    parent: 'Bookings and Reservations',
  },
  { label: 'Yesware', value: 'yesware', parent: 'Marketing Automation' },
  { label: 'Yext', value: 'yext', parent: 'Data Management' },
  { label: 'Yieldify', value: 'yieldify', parent: 'Conversion Optimization' },
  { label: 'Yotpo', value: 'yotpo', parent: 'Marketing Automation' },
  { label: 'Youtube', value: 'youtube', parent: 'Image and Video Services' },
  { label: 'Zaius', value: 'zaius', parent: 'Marketing Automation' },
  { label: 'Zedo', value: 'zedo', parent: 'Advertising' },
  { label: 'Zeit Now', value: 'zeit_now', parent: 'Web Hosting' },
  { label: 'Zen Cart', value: 'zen_cart', parent: 'eCommerce' },
  { label: 'Zendesk', value: 'zendesk', parent: 'Customer Support' },
  { label: 'ZenIQ', value: 'zeniq', parent: 'Marketing Automation' },
  { label: 'Zenreach', value: 'zenreach', parent: 'Conversion Optimization' },
  { label: 'Zoho CRM', value: 'zoho_crm', parent: 'CRM' },
  { label: 'Zopim', value: 'zopim', parent: 'Live Chat' },
  { label: 'Zuora', value: 'zuora', parent: 'Payment' },
  { label: 'Zype', value: 'zype', parent: 'Image and Video Services' },
];
